import React, { useState } from 'react';
import { Button } from 'src/components/atoms/Button';
import { Icon } from 'src/components/atoms/Icon';
import { InboxesList } from 'src/features/Inbox/components/templates/InboxesList';
import { InboxesContextProvider } from 'src/features/Inbox/contexts/InboxesListContext/InboxesContextProvider';
import { NewMessageModal } from 'src/features/Inbox/components/molecules/NewMessageModal';
import { useSendMessageMutation } from 'src/api/inboxes';
import { useAppContext } from 'src/contexts/AppContext';
import { SendMessagePayload } from 'src/api/inboxes';
import { InboxPageWrapper } from 'src/features/Inbox/components/atoms/InboxPageWrapper';

export const InboxesListPage: React.FC = () => {
  const [isNewMessageModalOpen, setIsNewMessageModalOpen] = useState(false);
  const { currentCustomer } = useAppContext();
  const sendMessageMutation = useSendMessageMutation(
    currentCustomer?.customerName ?? '',
  );

  const handleSendMessage = async (data: SendMessagePayload) => {
    await sendMessageMutation.mutateAsync({
      recipientUserIds: data.recipientUserIds,
      title: data.title,
      description: data.description,
    });
  };

  return (
    <InboxesContextProvider>
      <InboxPageWrapper
        pageTitle="Inbox"
        extraButtons={
          <Button
            buttonName="write-message"
            bg="icon.green"
            color="white"
            size="md"
            px={6}
            borderRadius="md"
            fontWeight="semibold"
            fontFamily="marketingPage"
            leftIcon={<Icon iconName="plus" boxSize={4} />}
            onClick={() => setIsNewMessageModalOpen(true)}
            _hover={{ bg: 'green.500' }}>
            Write a Message
          </Button>
        }>
        <InboxesList />
      </InboxPageWrapper>
      <NewMessageModal
        isOpen={isNewMessageModalOpen}
        onClose={() => setIsNewMessageModalOpen(false)}
        onSend={handleSendMessage}
        isLoading={sendMessageMutation.isLoading}
      />
    </InboxesContextProvider>
  );
};
